import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler, parseHeaderKey2DataHandler } from '../../../base/decorators';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
import { POLLING_KEY_CREATE, QQ_LOGIN, QQ_OAUTH_LOGIN, UPDATE_WECHAT_LOGIN_QRCODE_STATUS, WECHAT_OFFICIAL_ACCOUNT_OR_H5_LOGIN, WEWORK_LOGIN, WXQRCODE, } from './cgi-path';
import { IWechatLoginCase } from './login-params.interface';
var PRASE_HEADER_KEY_X_U = 'x-u';
var RES_DATA_KEY_X_U = 'userIndex';
var LoginRepository = /** @class */ (function () {
    function LoginRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    LoginRepository.prototype.pollingKeyCreate = function (ac) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "".concat(POLLING_KEY_CREATE, "?ac=").concat(ac);
                return [2 /*return*/, this.networkRequestService.instance.post(url, {
                        xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    })];
            });
        });
    };
    LoginRepository.prototype.getWeChatLogInQRURI = function () {
        return __awaiter(this, arguments, void 0, function (wechatLoginCase) {
            var requestUrl;
            if (wechatLoginCase === void 0) { wechatLoginCase = IWechatLoginCase.WECHAT_LOGIN_CASE_DEFAULT; }
            return __generator(this, function (_a) {
                requestUrl = addURLParameters(WECHAT_OFFICIAL_ACCOUNT_OR_H5_LOGIN, { case: wechatLoginCase });
                return [2 /*return*/, this.networkRequestService.instance.get(requestUrl)];
            });
        });
    };
    LoginRepository.prototype.getWeChatLogInQRCodeURI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, requestUrl;
            return __generator(this, function (_a) {
                params = {
                    ac: 'login',
                    ts: Date.now(),
                    page: encodeURIComponent('pages/landingpage/landingpage'),
                    checkKey: '1',
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                requestUrl = addURLParameters(WXQRCODE, params);
                return [2 /*return*/, this.networkRequestService.instance.get(requestUrl)];
            });
        });
    };
    LoginRepository.prototype.updateWeChatLoginQRCodeStatus = function (checkKey, data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, requestUrl;
            return __generator(this, function (_a) {
                params = __assign({ CheckKey: checkKey, u: 'login' }, data);
                requestUrl = addURLParameters(UPDATE_WECHAT_LOGIN_QRCODE_STATUS, params);
                return [2 /*return*/, this.networkRequestService.instance.post(requestUrl, undefined, { withCredentials: true })];
            });
        });
    };
    LoginRepository.prototype.updateEnterpriseWeChatLoginQRCodeStatus = function (checkKey) {
        return __awaiter(this, void 0, void 0, function () {
            var params, requestUrl;
            return __generator(this, function (_a) {
                params = {
                    CheckKey: checkKey,
                };
                requestUrl = addURLParameters(UPDATE_WECHAT_LOGIN_QRCODE_STATUS, params);
                return [2 /*return*/, this.networkRequestService.instance.post(requestUrl, undefined, { withCredentials: true })];
            });
        });
    };
    LoginRepository.prototype.checkQQLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "".concat(QQ_LOGIN, "?u=login");
                return [2 /*return*/, this.networkRequestService.instance.post(url, {
                        xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    })];
            });
        });
    };
    LoginRepository.prototype.checkQQOAuthLogin = function (code, data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, requestUrl;
            return __generator(this, function (_a) {
                params = __assign({ state: 'state', xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) || '', code: code }, data);
                requestUrl = addURLParameters(QQ_OAUTH_LOGIN, params);
                return [2 /*return*/, this.networkRequestService.instance.get(requestUrl, { withCredentials: true })];
            });
        });
    };
    LoginRepository.prototype.weworkLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "".concat(WEWORK_LOGIN, "?u=login");
                return [2 /*return*/, this.networkRequestService.instance.post(url, {
                        xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    })];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "pollingKeyCreate", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "getWeChatLogInQRURI", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "getWeChatLogInQRCodeURI", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        parseHeaderKey2DataHandler(PRASE_HEADER_KEY_X_U, RES_DATA_KEY_X_U),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "updateWeChatLoginQRCodeStatus", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "updateEnterpriseWeChatLoginQRCodeStatus", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        parseHeaderKey2DataHandler(PRASE_HEADER_KEY_X_U, RES_DATA_KEY_X_U),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "checkQQLogin", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        parseHeaderKey2DataHandler(PRASE_HEADER_KEY_X_U, RES_DATA_KEY_X_U),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "checkQQOAuthLogin", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        parseHeaderKey2DataHandler(PRASE_HEADER_KEY_X_U, RES_DATA_KEY_X_U),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LoginRepository.prototype, "weworkLogin", null);
    LoginRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], LoginRepository);
    return LoginRepository;
}());
export default LoginRepository;
